import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Avatar from 'fe-design-base/molecules/Avatar';

import { df, moment } from 'util/dateTime';

const I18N_PATH = 'my_week.user.shift_trade_requests.smart_cover_requests';

interface Props {
  avatarUrl: string;
  requesterName: string;
  createdAt: string | Date;
}

const SmartCoverRequestAvatar = ({
  avatarUrl,
  requesterName,
  createdAt,
}: Props) => {
  const now = moment();
  const createdAtMoment = moment(createdAt);

  let requestTimeElapsed: string;

  if (createdAtMoment.isSame(now, 'day')) {
    requestTimeElapsed = createdAtMoment.format(df('msg_time'));
  } else if (createdAtMoment.isSame(now.subtract(1, 'day'), 'day')) {
    requestTimeElapsed = 'Yesterday';
  } else if (createdAtMoment.isSame(now.subtract(1, 'week'), 'day')) {
    requestTimeElapsed = createdAtMoment.format(df('full_wday'));
  } else if (
    createdAtMoment.isBetween(
      now.subtract(2, 'days'),
      now.subtract(1, 'day'),
      'day',
      '[]'
    )
  ) {
    requestTimeElapsed = `Between ${createdAtMoment.format(
      df('full_wday')
    )} and ${now.format(df('full_wday'))}`;
  } else {
    requestTimeElapsed = createdAtMoment.format(df('pretty_no_wday'));
  }

  return (
    <Box maxw={282} gap={6} flex justifySpaceBetween>
      <Avatar size="large" image={avatarUrl} />
      <Box flex column>
        <Text variant="bodyBold">{requesterName}</Text>
        <Box flex gap={2} alignItemsCenter>
          <Text
            i18n={`${I18N_PATH}.requested_a_cover`}
            color="mono700"
            variant="bodySm"
          />
          <Text color="mono700" variant="bodySmTight">
            &bull;
          </Text>
          <Text color="mono700" variant="bodySmTight">
            {requestTimeElapsed}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default SmartCoverRequestAvatar;
